<template>
	<div class="cont">
		<div class="sidebar">
			<p class="user-name">
				欢迎~ {{UserEmai}}
			</p>
			<el-menu
			      default-active="2"
			      class="el-menu-vertical-demo"
			      @open="handleOpen"
			      @close="handleClose"
			      background-color="#001428"
			      text-color="#fff"
			      active-text-color="#2D8CF0">
				  <el-submenu index="1">
				    <template slot="title">
				      <i class="el-icon-monitor"></i>
				      <span>设备管理</span>
				    </template>
				    <el-menu-item-group>
						<el-menu-item index="1-1">
				  			<router-link to="./managementlist">授权设备管理</router-link>
						</el-menu-item>
						<el-menu-item index="1-2">
				  			<router-link to="./equipment-application">申请中设备</router-link>
						</el-menu-item>
						<el-menu-item index="1-3">
				  			<router-link to="./disabled-devices">被禁设备列表</router-link>
						</el-menu-item>
				    </el-menu-item-group>
				  </el-submenu>
				  <el-submenu index="3">
				    <template slot="title">
				      <i class="el-icon-user"></i>
				      <span>我的账户</span>
				    </template>
				    <el-menu-item-group>
				      <!-- <template slot="title">分组一</template> -->
						<el-menu-item index="2-1">
				  			<router-link to="./changepassword">修改密码</router-link>
						</el-menu-item>
				    </el-menu-item-group>
				  </el-submenu>
				  <p @click="LogOut"> {{`退出登录 < `}}</p>
			    </el-menu>
		</div>
		<div class="page-cont">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
  export default {
    data() {
      return {
		UserEmai:localStorage.getItem("UserEmail")
      };
    },
	beforeMount() {
		let This = this
		let UserEmail=localStorage.getItem("UserEmail")
		This.UserEmail=UserEmail
		let token = localStorage.getItem('token')
		axios(
			{
			   headers: {
				Authorization:'Bearer '+token
			  },
			  method:'get',
			  url: This.$store.state.ServerAddress+"/api/admin/get-userinfo",
			  params : {
				  adminAccount:UserEmail
				}
			}).then((rest)=>{
				// console.log(rest);
				if(rest.data.success){
					console.log(UserEmail+'验证成功');
					This.UserEmai = rest.data.data.admin_name || rest.data.data.admin_account;
					// This.$router.push('/phonebook')
				}else{
					// console.log(token);
					This.$message.error(rest.data.msg || '验证失败,请重新登录');
					localStorage.removeItem('UserEmail')
					localStorage.removeItem('token')
					This.$router.push('/login')
				}
			},(err)=>{
				console.log(err);
				if (err.response && err.response.status === 401) {
					This.$message.error('登录已过期，请重新登录');
					localStorage.removeItem('UserEmail');
					localStorage.removeItem('token');
					This.$router.push('/login');
				} else {
					This.$message.error('网络连接失败');
				}
			})
		console.log(UserEmail);
	},
    methods: {
		LogOut(){
			this.$confirm('是否退出当前账户?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				localStorage.removeItem('UserEmail')
				localStorage.removeItem('token')
				this.$router.push('/')
				location.reload();
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消退出'
				});          
			});
		},
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>

<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
	margin-top: 30px;
  }
  .cont{
	  width: 100%;
	  min-height: 100vh;
	  background-color: #F2F6FC;
	  display: flex;
	  color: white;
  }
  .sidebar{
	  text-align: center;
	  width: 200px;
	  background-color: #001428;
  }
  .user-name{
	  margin: 0 auto;
	  margin-top: 30px;
  }
  a{
	  text-decoration: none;
	  color: white;
  }
</style>